import { Link as RouterLink } from 'react-router-dom';
import {
    Box,
    Link,
    Typography,
    Container,
    styled,
    Card, Alert
} from '@mui/material';
import useAuth from 'src/hooks/useAuth';
import JWTLogin from '../LoginJWT';
import { useTranslation } from 'react-i18next';
import React, { useState } from "react";
import { QrReader } from 'react-qr-reader';


const MainContent = styled(Box)(
    () => `
    height: 85%;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`
);


function LoginBasic() {
    const { method } = useAuth() as any;
    const { t }: { t: any } = useTranslation();
    const [data, setData] = useState('');

    return (
        <>
            <MainContent>
                <Container maxWidth="md">
                    <Card
                        sx={{
                            p: 4,
                        }}
                    >
                        {data == null ?
                            <QrReader
                                onResult={(result: any, error) => {
                                    if (!!result) {
                                        setData(result?.text);
                                    }

                                    if (!!error) {
                                        console.info(error);
                                    }
                                }}
                                constraints={undefined} /> : null}
                        <p>{data}</p>
                        <Box>
                            <Typography
                                variant="h2"
                            >
                                {t("Login")}
                            </Typography>
                            <Typography
                                variant="h4"
                                color="secondary"
                                fontWeight="normal"
                                sx={{
                                    mb: 2
                                }}
                            >
                                {t('Fill in the fields below to sign into your account.')}
                            </Typography>

                        </Box>
                        <JWTLogin />
                    </Card>
                </Container>
            </MainContent>

            <Box textAlign="center">
                <Typography
                    component="span"
                    variant="subtitle1"
                    color="text.primary"
                    fontWeight="bold"
                >
                    {t("Don’t have an account yet? ")}
                </Typography>{' '}
                <Link component={RouterLink} to="/account/register">
                    <b>
                        {t("Register here")}
                    </b>
                </Link>
            </Box>
            <Box textAlign="center" sx={{ mb: 1 }}>
                <Typography
                    component="span"
                    variant="body1"
                    color="text.primary"
                    fontSize={10}
                >
                    {t('Powered by Connexus')}
                </Typography>{' '}
            </Box>
        </>
    );
}

export default LoginBasic;
